// ===============================
// 🔧 CRUSHER UI KIT CORE IMPORTS
// ===============================

// --- Generated by Style Dictionary ---
import '../css/tokens.css';
import '../css/modes.css';
import '../css/semantic.css';
import '../css/bridge.css';
import '../css/code-theme.css';
import '../css/theme-scenes.css';
import '../css/dialect-overrides.css';

// Per-theme token overlays (generated)
import '../css/themes/glass.css';
import '../css/themes/brutal.css';
import '../css/themes/neumorph.css';
import '../css/themes/neobrutal.css';
import '../css/themes/minimal.css';
import '../css/themes/futuristic.css';
import '../css/themes/bento.css';

// --- Base SCSS (Utilities, Reset, Typography) ---
import '../scss/main.scss';

// ===============================
// 🧩 COMPONENT REGISTRATION
// ===============================

// --- Atoms ---
import '../components/atoms/crusher-button.js';
import '../components/atoms/crusher-icon-link.js';
import '../components/atoms/crusher-input.js';
import '../components/atoms/crusher-textarea.js';
import '../components/atoms/crusher-checkbox.js';
import '../components/atoms/crusher-switch.js';
import '../components/atoms/crusher-chip.js';
import '../components/atoms/crusher-code-block.js';
import '../components/atoms/crusher-tooltip.js';
import '../components/atoms/crusher-badge.js';
import '../components/atoms/crusher-currency-input.js';

// --- Molecules ---
import '../components/molecules/crusher-card.js';
import '../components/molecules/crusher-card-link.js';
import '../components/molecules/crusher-grid.js';
import '../components/molecules/crusher-modal.js';
import '../components/molecules/crusher-skill-bar.js';
import '../components/molecules/crusher-stack.js';
import '../components/molecules/crusher-style-switcher.js';
import '../components/molecules/crusher-audio-player.js';
import '../components/molecules/crusher-toast-center.js';
import '../components/molecules/crusher-dropdown.js';
import '../components/molecules/crusher-empty-state.js';
import '../components/molecules/crusher-filter-bar.js';
import '../components/molecules/crusher-tabs.js';
import '../components/molecules/crusher-command-palette.js';
import '../components/molecules/crusher-select.js';
import '../components/molecules/crusher-menubar.js';
import '../components/molecules/crusher-stat.js';
import '../components/molecules/crusher-toolbar.js';
import '../components/molecules/crusher-alert.js';
import '../components/molecules/crusher-banner.js';
import '../components/molecules/crusher-disclosure.js';
import '../components/molecules/crusher-connection-status.js';
import '../components/molecules/crusher-avatar-menu.js';
import '../components/molecules/crusher-plan-card.js';
import '../components/molecules/crusher-invoice-list.js';
import '../components/molecules/crusher-payment-method-card.js';
import '../components/molecules/crusher-file-upload.js';
import '../components/molecules/crusher-sparkline.js';

// --- Organisms ---
import '../components/organisms/crusher-app-shell.js';
import '../components/organisms/crusher-nav-list.js';
import '../components/organisms/crusher-page-header.js';
import '../components/organisms/crusher-section-title.js';
import '../components/organisms/crusher-timeline-item.js';
import '../components/organisms/crusher-timeline.js';
import '../components/organisms/crusher-table.js';

// --- Form primitives ---
import '../components/forms/crusher-field.js';
import '../components/forms/crusher-label.js';
import '../components/forms/crusher-hint.js';
import '../components/forms/crusher-error.js';

// --- Runtime (Theme + Mode Switching) ---
import '../runtime/theme.js';
import '../runtime/toast.js'; // exposes window.crusherToast(...)
import '../runtime/command-palette.js';

// ===============================
// 🚀 READY
// ===============================
console.log('%c Crusher UI Kit Loaded ', 'background:#22c55e;color:#fff;padding:4px 8px;border-radius:4px;');
